import { ButtonHTMLAttributes } from "react";
import { cn } from "../../utls/utils";

interface StopButtonProps {
  isDisabled?: boolean;
  onClick?: () => void;
  color?:
    | "teal"
    | "emerald"
    | "light"
    | "purple"
    | "default"
    | "terracotta"
    | "beige"
    | "brown"
    | "cream";
}

export function StopButton({
  isDisabled,
  onClick,
  color = "terracotta",
  className,
  ...props
}: StopButtonProps & ButtonHTMLAttributes<HTMLButtonElement>) {
  // Color variants
  const colorStyles = {
    // Harper brand colors
    terracotta:
      "border-terracotta-500 bg-terracotta-500 hover:bg-terracotta-600 focus:bg-terracotta-600",
    beige:
      "border-beige-500 bg-beige-500 hover:bg-beige-600 focus:bg-beige-600",
    brown:
      "border-brown-500 bg-brown-500 hover:bg-brown-600 focus:bg-brown-600",
    cream:
      "border-cream-500 bg-cream-500 hover:bg-cream-600 focus:bg-cream-600",

    // Legacy color variants
    teal: "border-teal-500 bg-teal-500 hover:bg-teal-600 focus:bg-teal-600",
    emerald:
      "border-emerald-500 bg-emerald-500 hover:bg-emerald-600 focus:bg-emerald-600",
    light:
      "border-lightGreen-400 bg-lightGreen-400 hover:bg-lightGreen-500 focus:bg-lightGreen-500",
    purple:
      "border-purple-400 bg-purple-400 hover:bg-purple-500 focus:bg-purple-500",
    default:
      "border-terracotta-500 bg-terracotta-500 hover:bg-terracotta-600 focus:bg-terracotta-600",
  };

  return (
    <button
      data-testid="stop-button"
      disabled={isDisabled}
      onClick={onClick}
      type="button"
      className={cn(
        "rounded-lg w-8 h-8 flex items-center justify-center transition-colors duration-150",
        colorStyles[color],
        isDisabled && "opacity-50 cursor-not-allowed",
        className
      )}
      {...props}
    >
      <div
        className={`w-[10px] h-[10px] ${
          color === "beige" || color === "cream" ? "bg-brown-800" : "bg-white"
        } rounded-sm`}
      />
    </button>
  );
}
